(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/app-notifications/app-notifications-service.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/app-notifications/app-notifications-service.js');
'use strict';

const {
  jupiter
} = svs.core;


const getPlayerPreferencesAsync = async () => {
  try {
    const options = {
      method: 'GET',
      path: '/player/1/preferences/30'
    };
    const {
      response
    } = await jupiter.callAsync(options);
    return {
      error: response === null || response === void 0 ? void 0 : response.error,
      preferences: response === null || response === void 0 ? void 0 : response.preferences
    };
  } catch (err) {
    svs.myProfile.logger.debug('app-notification-service file: getPlayerPreferences error', err);
    return {
      error: err,
      settings: {}
    };
  }
};
const putCustomersProductTogglesAsync = async settings => {
  try {
    const {
      response,
      status
    } = await jupiter.callAsync({
      method: 'PUT',
      path: '/notification/1/playersubscriptions/producttoggles',
      data: settings
    });
    if (status !== 'success') {
      svs.myProfile.logger.warn('PersonalizationSettingsService:setCustomersSettingsAsync error response from jupiter:', response.error);
      return {
        status,
        error: response.error
      };
    }
    return {
      status,
      error: response.error
    };
  } catch (err) {
    svs.myProfile.logger.warn(err);
    return {
      status: 'error',
      error: err
    };
  }
};
svs.myProfile.react.pages.notifications.appNotifications.appNotificationsService = {
  getPlayerPreferencesAsync,
  putCustomersProductTogglesAsync
};

 })(window);